<script lang="ts">
	import { format } from 'svelte-i18n';

	import UserLogModal from './UserLogModal.svelte';

	import { Text } from '@Shelly/shelly-design-system';

	let showModal = false;

	const openLog = (e: MouseEvent): void => {
		e.preventDefault();
		showModal = true;
	};
</script>

<div class="width-sm-full width-md-auto">
	{#if import.meta.env.DEV}
		<Text
			href="#"
			styleType="body-small"
			aria-label={$format('button_view_user_log', { default: 'View log' })}
			on:click={openLog}
		>
			{$format('button_view_user_log', { default: 'View log' })}
		</Text>
		<UserLogModal bind:showModal />
	{/if}
</div>
